import React from "react";
import { cn } from "../../utils/cn";

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "full";
  padding?: "none" | "sm" | "md" | "lg";
  fluid?: boolean;
}

const Container: React.FC<ContainerProps> = ({
  className,
  size = "xl",
  padding = "md",
  fluid = false,
  children,
  ...props
}) => {
  const sizeClasses = {
    sm: "max-w-(--breakpoint-sm)",
    md: "max-w-(--breakpoint-md)",
    lg: "max-w-(--breakpoint-lg)",
    xl: "max-w-(--breakpoint-xl)",
    "2xl": "max-w-(--breakpoint-2xl)",
    full: "max-w-full",
  };

  const paddingClasses = {
    none: "",
    sm: "px-4 sm:px-5 md:px-6",
    md: "px-4 sm:px-5 md:px-6 lg:px-8 xl:px-10",
    lg: "px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-16",
  };

  return (
    <div
      className={cn(
        "w-full mx-auto",
        !fluid && sizeClasses[size],
        paddingClasses[padding],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default Container;
